<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small">
      <div class="inner"><i class="ti ti-user-x"></i></div>
    </div>
    <span class="title ms-2">Demande de radiation</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <form [formGroup]="radiationForm" class="d-flex flex-column gap-3 w-100 mt-4" (ngSubmit)="submitRadiation()"
    id="radiation-form">
    <!-- Beneficiaries selection -->
    <div class="d-flex flex-column gap-2 form-group w-100" *ngIf="beneficiaries?.length > 0 && env.config?.memberActions?.allowBeneficiaryRadiation !== false">
      <label class="form-label required">Qui est concerné par la radiation ?</label>

      <p class="d-flex align-items-center text-muted">
        <small>
          La radiation du salarié entraîne automatiquement celle de tous ses bénéficiaires.
        </small>
      </p>

      <div class="form-check">
        <input id="includeAll" type="checkbox" class="form-check-input" formControlName="includeAll">
        <label class="form-check-label ms-2 fw-semibold" for="includeAll">
          Salarié et tous les bénéficiaires
        </label>
      </div>

      <div class="ms-3" [class.opacity-50]="radiationForm.value.includeAll">
        <small class="text-muted d-block mb-2" *ngIf="!radiationForm.value.includeAll">
          Ou sélectionnez uniquement certains bénéficiaires :
        </small>
        <small class="text-muted d-block mb-2" *ngIf="radiationForm.value.includeAll">
          Tous les bénéficiaires seront inclus dans la radiation :
        </small>
        <div class="form-check" *ngFor="let b of beneficiaries">
          <input class="form-check-input" type="checkbox" [id]="'beneficiary-' + b.id" [name]="'beneficiary-' + b.id"
            [checked]="selectedBeneficiaryIds.has(b.id)" [disabled]="radiationForm.value.includeAll"
            (change)="onBeneficiaryChange($event, b.id)">
          <label class="form-check-label ms-2 fw-normal" [for]="'beneficiary-' + b.id">
            {{ b.firstname }} {{ b.lastname }} — {{ b.typeFormatted() }}
          </label>
        </div>
      </div>
      <div class="invalid-feedback d-block"
        *ngIf="radiationForm.errors?.['selectionRequired'] && (radiationForm.touched || radiationForm.dirty)">
        Veuillez sélectionner au moins un bénéficiaire ou cocher « Salarié et tous les bénéficiaires ».
      </div>
    </div>

    <!-- Date of radiation -->
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Date d'effet de la radiation</label>
      <input class="form-control" type="date" formControlName="effectiveDate"
        [class.is-invalid]="radiationForm.get('effectiveDate').invalid && radiationForm.get('effectiveDate').touched">
      <div class="invalid-feedback"
        *ngIf="radiationForm.get('effectiveDate').invalid && radiationForm.get('effectiveDate').touched">
        <div *ngIf="radiationForm.get('effectiveDate').errors?.['required']">
          La date d'effet est obligatoire
        </div>
      </div>
    </div>

    <!-- Reason selection -->
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Motif de la radiation</label>
      <app-select [options]="radiationReasons" formControlName="reason" (change)="onReasonChange($event)"
        *ngIf="radiationReasons.length > 0"
        [class.is-invalid]="radiationForm.get('reason').invalid && radiationForm.get('reason').touched"
        placeholder="Sélectionnez un motif">
      </app-select>
      <div class="invalid-feedback" *ngIf="radiationForm.get('reason').invalid && radiationForm.get('reason').touched">
        <div *ngIf="radiationForm.get('reason').errors?.['required']">
          Le motif de radiation est obligatoire
        </div>
      </div>
    </div>

    <!-- Documents upload section -->
    <div class="d-flex flex-column gap-3" *ngIf="selectedReasonDocuments.length > 0">
      <label class="form-label">Documents justificatifs</label>
      <div class="row g-3" formArrayName="documents">
        <div class="col-12" *ngFor="let doc of selectedReasonDocuments; let i = index">
          <div class="d-flex flex-column gap-2">
            <label class="form-label fw-normal" [class.required]="doc.required">
              {{ doc.label }}
            </label>
            <div class="uploaded-file" *ngIf="uploadedDocuments.has(doc.id)">
              <span>{{ uploadedDocuments.get(doc.id).name }}</span>
              <button type="button" class="button xs icon transparent" (click)="removeDocument(doc.id, i)">
                <i class="ti ti-trash"></i>
              </button>
            </div>
            <app-file-uploader [multipleSelection]="false" (onFilesAdded)="onDocumentUploaded($event, doc.id, i)"
              [isInvalid]="documentsArray.at(i)?.invalid && documentsArray.at(i)?.touched"
              *ngIf="!uploadedDocuments.has(doc.id)">
            </app-file-uploader>
            <div class="invalid-feedback d-block"
              *ngIf="documentsArray.at(i)?.invalid && documentsArray.at(i)?.touched">
              Ce document est obligatoire
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning d-flex align-items-start">
      <i class="ti ti-alert-triangle me-2 mt-1"></i>
      <div>
        <strong>Attention :</strong> Cette action est irréversible. Un email sera envoyé à la mutuelle pour la
        radiation. Elle sera effective à la date indiquée et les personnes concernées ne seront plus couvertes par le
        contrat.
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Annuler</button>
  <button class="button m primary" type="submit" form="radiation-form" [disabled]="radiationForm.invalid">
    Confirmer la radiation
  </button>
</div>